import React, { useState } from 'react'
    import { Link, useLocation } from 'react-router-dom'
    import { Film, Menu, X } from 'lucide-react'
    import DarkModeToggle from './DarkModeToggle'
    import { useTheme } from '../contexts/ThemeContext'
    import { trackHeaderFooterClick, detectDeviceType } from '../utils/headerFooterAnalytics'

    const Navbar = () => {
      const [isOpen, setIsOpen] = useState(false)
      const location = useLocation()
      const { isDark } = useTheme()

      const navLinks = [
        { name: 'Home', path: '/', id: 'home' },
        { name: 'Awards', path: '/awards', id: 'awards' },
        { name: 'Behind-the-Scenes', path: '/behind-the-scenes', id: 'behind-scenes' },
        { name: 'Team', path: '/team', id: 'team' },
        { name: 'Careers', path: '/careers', id: 'careers' },
        { name: 'News', path: '/news', id: 'news' },
        { name: 'Contact', path: '/contact', id: 'contact' },
      ]

      const isActive = (path) => location.pathname === path

      const handleNavClick = (link) => {
        trackHeaderFooterClick('header', `menu:${link.id}`, {
          label: link.name,
          href: link.path,
          device: detectDeviceType(),
        })
      }

      return (
        <nav
          className={`sticky top-0 z-50 transition-colors duration-300 ${
            isDark ? 'bg-gray-900/95 backdrop-blur border-b border-gray-800' : 'bg-white shadow-md'
          }`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-20">
              <Link to="/" className="flex items-center gap-3 group">
                <div className="w-12 h-12 bg-gradient-to-br from-bengal-green to-bengal-orange rounded-lg flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow duration-200">
                  <Film className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h1
                    className={`text-2xl font-bold hero-title ${
                      isDark ? 'text-white' : 'text-gray-900'
                    }`}
                  >
                    Shikdar Films
                  </h1>
                  <p
                    className={`text-xs font-medium ${
                      isDark ? 'text-gray-300' : 'text-gray-600'
                    }`}
                  >
                    Dhaka, Bangladesh
                  </p>
                </div>
              </Link>

              <div className="hidden lg:flex items-center gap-6">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => handleNavClick(link)}
                    className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                      isActive(link.path)
                        ? 'text-bengal-green border-b-2 border-bengal-green'
                        : isDark
                        ? 'text-gray-200 hover:text-bengal-green'
                        : 'text-gray-700 hover:text-bengal-green'
                    }`}
                  >
                    {link.name}
                  </Link>
                ))}
                <div className="pl-4 border-l border-gray-200 dark:border-gray-700">
                  <DarkModeToggle size="small" showLabel={false} />
                </div>
              </div>

              <div className="flex items-center gap-3 lg:hidden">
                <DarkModeToggle size="small" showLabel={false} />
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200"
                >
                  {isOpen ? (
                    <X
                      className={`w-6 h-6 ${isDark ? 'text-white' : 'text-gray-900'}`}
                    />
                  ) : (
                    <Menu
                      className={`w-6 h-6 ${isDark ? 'text-white' : 'text-gray-900'}`}
                    />
                  )}
                </button>
              </div>
            </div>

            {isOpen && (
              <div className="lg:hidden py-4 border-t border-gray-200 dark:border-gray-700">
                <div className="flex flex-col gap-4">
                  {navLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      onClick={() => {
                        handleNavClick(link)
                        setIsOpen(false)
                      }}
                      className={`text-base font-medium px-4 py-2 rounded-lg transition-colors duration-200 ${
                        isActive(link.path)
                          ? 'bg-bengal-green text-white'
                          : isDark
                          ? 'text-gray-200 hover:bg-gray-800'
                          : 'text-gray-700 hover:bg-gray-100'
                      }`}
                    >
                      {link.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </nav>
      )
    }

    export default Navbar